import React from 'react';

import FaqAccordionItem from '../../shared/faq-accordion-item/view/FaqAccordionItem';
import { useAccordion } from '../../shared/core/hooks/useAccordion';

import styles from '../styles/common/Faqs.module.scss';

interface Faq {
  question: string;
  answer: string;
}

interface FaqsSection {
  title: string;
  sub_text: string;
  faqs: Faq[];
  toggle_icon: { path: string; alt_text: string };
}

interface FaqsCmpProps {
  faqs_section: FaqsSection;
  hide_desc?: boolean;
  custom_styles?: React.CSSProperties;
}

function FaqsCmp({
  faqs_section,
  hide_desc = true,
  custom_styles,
}: FaqsCmpProps): React.ReactElement {
  const { isActive, accordionOnClick } = useAccordion();

  return (
    <div className={styles['faqs-container']} style={custom_styles}>
      <h2 className={styles['header']}>{faqs_section.title}</h2>
      {hide_desc ? null : (
        <div className={styles['desc-wrapper']}>{faqs_section.sub_text}</div>
      )}
      <div className={styles['faq-wrapper']}>
        {faqs_section.faqs.map((faq, index) => (
          <FaqAccordionItem
            key={faq.question}
            onClick={() => accordionOnClick(index)}
            isActive={isActive(index)}
            containerClass={styles['item-wrapper']}
            headerClass={styles['question']}
            bodyClass={styles['answer']}
            header={faq.question}
            content={faq.answer}
            toggle_icon={faqs_section.toggle_icon}
          />
        ))}
      </div>
    </div>
  );
}

export default FaqsCmp;
